import { render, staticRenderFns } from "./AddNigerianSchool.vue?vue&type=template&id=60e0605c&scoped=true"
import script from "./AddNigerianSchool.vue?vue&type=script&lang=js"
export * from "./AddNigerianSchool.vue?vue&type=script&lang=js"
import style0 from "./AddNigerianSchool.vue?vue&type=style&index=0&id=60e0605c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0605c",
  null
  
)

export default component.exports